import { h, Component } from 'preact';
import Store from 'store/store';
import * as cookies from 'utils/cookies';
import { joinClasses } from 'utils/utils';

import s from 'components/shared/cookies/preferences.sss';

const requiredLevels = cookies.levels.filter(level => level.required).map(level => level.type);

export default class Preferences extends Component {
	constructor(props) {
		super(props);

		this.onCookieRegistered = this.onCookieRegistered.bind(this);
		this.toggleDisableAll = this.toggleDisableAll.bind(this);
		this.onSubmit = this.onSubmit.bind(this);

		// let activeLevels = cookies.activeLevels;
		this.displayed = cookies.getActiveLevels();
		let defaultValues = cookies.levels.reduce((values, level) => {
			let value = props.selected ? !!props.selected[level.type] : this.displayed.includes(level.type);
			// if required, force true
			values[level.type] = level.required || value;
			return values;
		}, {});
		this.state = {
			values: defaultValues
		};
	}

	componentDidMount() {
		Store.on('COOKIE_REGISTERED', this.onCookieRegistered);
	}

	componentWillUnmount() {
		Store.off('COOKIE_REGISTERED', this.onCookieRegistered);
	}

	componentWillReceiveProps(nextProps) {
		if (!this.props.active && nextProps.active) {
			this.restoredOverflow = document.body.style.overflow;
			document.body.style.overflow = 'hidden';
		}
		if (!nextProps.active && this.props.active) {
			document.body.style.overflow = this.restoredOverflow;
		}
		if (nextProps.selected !== this.props.selected && nextProps.selected) {
			const values = Object.assign({}, this.state.values);
			cookies.levels.forEach(level => {
				if (level.required) {
					return;
				}
				values[level.type] = !!nextProps.selected[level.type];
			});
			this.setState({ values });
		}
	}

	onCookieRegistered() {
		this.displayed = cookies.getActiveLevels();
	}

	toggleDisableAll(e) {
		let val = e.target.checked;
		let setAllTo = !val;
		let newValues = cookies.levels.reduce((values, level) => {
			let value = setAllTo;
			if (level.required) {
				value = true;
			} else if (!this.displayed.includes(level.type)) {
				value = false;
			}
			values[level.type] = value;
			return values;
		}, {});
		this.setState({ values: newValues });
	}

	toggle(type, e) {
		let val = e.target.checked;
		this.setState({ values: Object.assign({}, this.state.values, { [type]: val }) });
	}

	onSubmit(e) {
		e.preventDefault();
		Store.emit('SET_COOKIE_LEVELS', this.state.values);
		Store.emit('TOGGLE_COOKIES_PREFERENCE_CENTER', false);
	}

	renderLine(name, description, checked, onChange) {
		let indicator = <div class={s.indicator} />;
		if (checked === 'required') {
			indicator = <div class={s.required}>Required</div>;
		}
		return (
			<label class={s.line} key={name}>
				<div class={s.name}>{name}</div>
				<input class={s.input} type="checkbox" checked={!!checked} onChange={onChange} />
				{indicator}
				<div class={s.description}>{description}</div>
			</label>
		);
	}

	render() {
		let allDisabled = this.displayed.every(level => requiredLevels.includes(level) || !this.state.values[level]);
		return (
			<div class={joinClasses(s.container, this.props.active && s.active)}>
				<form class={s.content} onSubmit={this.onSubmit}>
					<div class={s.scrollSection}>
						<div class={s.header}>
							Consent Management
						</div>
						<div class={s.info}>
							When you visit any web site, it may store or retrieve information on your browser, mostly in the form of cookies. Because we respect your right to privacy, you can choose not to allow some types of services. However, not allowing some types of services may affect your experience of the site and the services we are able to offer.
						</div>
						{this.renderLine('Disable All', '', allDisabled, this.toggleDisableAll)}
						<div class={s.options}>
							{this.displayed.map(level => {
								const details = cookies.levels.find(l => l.type === level);
								if (!details) {
									return;
								}
								return this.renderLine(
									details.name,
									details.description,
									details.required ? 'required' : this.state.values[level],
									e => this.toggle(level, e)
								);
							})}
						</div>
					</div>
					<div class={s.buttons}>
						<button class={s.save} type="submit">
							Save Settings
						</button>
					</div>
				</form>
			</div>
		);
	}
}
